export class ManagedBy {
    ID?: number;
    Code?: string;
    Name?: string;
    FullName?: string;
}

export default ManagedBy;